import { Link } from 'react-router-dom';

const About = () => {
    return ( 
        <div className="about">
        <div className="section techwix-about-section-04 section-padding">
            <div className="shape-1"></div>
            <div className="container">
                <div className="about-wrap">
                    <div className="row">
                        <div className="col-lg-6">

                            <div className="about-content-wrap" style={{textAlign: "left"}}>
                                <div className="section-title">
                                    <h3 className="sub-title">Who we are</h3>
                                    <h2 className="title">Highly Tailored IT Design, Management & Support Services.</h2>
                                </div>
                                <p className="text">At TMT, we are at the forefront of technological innovation, pioneering solutions that
                                transform businesses and industries. Our commitment to excellence and a passion for innovation drives us to
                                deliver tailored technology services that not only meet but exceed your expectations.</p>
                                <div className="about-author-info-wrap">
                                    {/* <div className="about-author">
                                        <img src="assets/images/sign.png" alt="" />
                                        <h3 className="name">Okoro Oreva</h3>
                                        <span className="designation">CEO, TMT</span>
                                    </div> */}
                                    <div className="about-info">
                                        <p>Call to ask any question </p>
                                        <a href="tel:+2349038224320">
                                        <h3 className="number">+234 903-822-4320</h3>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-img-wrap">
                                <div className="play-btn-02">
                                    <Link className="popup-video" to="#"><i className="fas fa-play"></i></Link>
                                </div>
                                <div className="about-img about-img-big">
                                    <img src="assets/images/about-big2.jpg" alt="" />
                                </div>
                                <div className="about-img about-img-sm">
                                    <img src="assets/images/about-sm2.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section techwix-counter-section-02">
            <div className="container">
                <div className="counter-wrap">
                    <div className="row">
                        <div className="col-xl-3 col-md-6">
                            <div className="single-counter">
                                <div className="counter-img">
                                    <img src="assets/images/counter-1.png" alt="" />
                                </div>
                                <div className="counter-content">
                                    <span className="">19</span>
                                    <p>Happy clients</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="single-counter">
                                <div className="counter-img">
                                    <img src="assets/images/counter-2.png" alt="" />
                                </div>
                                <div className="counter-content">
                                    <span className="">27</span>
                                    <p>Finished projects</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="single-counter">
                                <div className="counter-img">
                                    <img src="assets/images/counter-3.png" alt="" />
                                </div>
                                <div className="counter-content">
                                    <span className="">8</span>
                                    <p>Skilled Experts</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="single-counter single-counter-4">
                                <div className="counter-img">
                                    <img src="assets/images/counter-1.png" alt="" />
                                </div>
                                <div className="counter-content">
                                    <span className="">5</span>
                                    <p>Media Posts</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section techwix-choose-us-section section-padding" style={{backgroundImage: "url(assets/images/bg/choose-us-bg.jpg)"}}>
            <div className="container">
                <div className="choose-us-wrap">
                    <div className="section-title text-center">
                        <h3 className="sub-title">REASON TO CHOOSE US</h3>
                        <h2 className="title">We provide truly prominent IT solutions.</h2>
                    </div>
                    <div className="choose-us-content-wrap">
                        <div className="row" style={{textAlign: "left"}}>
                            <div className="col-lg-4 col-md-6">
                                <div className="choose-us-item">
                                    <div className="choose-us-img">
                                        <Link to="/service"><img src="assets/images/about-crop.jpg" alt="" /></Link>
                                        <div className="choose-us-content">
                                            <h3 className="title">Information managemnet system</h3>
                                            <p>Maximize efficiency with our Information Management System expertise. Streamline operations and boost productivity!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="choose-us-item">
                                    <div className="choose-us-img">
                                        <Link to="/service"><img src="assets/images/choose-us2.jpg" alt="" /></Link>
                                        <div className="choose-us-content">
                                            <h3 className="title">Information Database Security</h3>
                                            <p>Protect your data with our Information Database Security solutions. Safeguard information, ensure compliance, and gain peace of mind.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="choose-us-item">
                                    <div className="choose-us-img">
                                        <Link to="/service"><img src="assets/images/choose-us3.jpg" alt="" /></Link>
                                        <div className="choose-us-content">
                                            <h3 className="title">Multifunctional Technology</h3>
                                            <p>Embrace efficiency with our Multifunctional Technology solutions. Simplify operations, boost productivity, and drive success</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="more-choose-content text-center">
                                    <p>Learn more about <Link to="/service">More reason <i className="fas fa-long-arrow-alt-right"></i></Link> </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section techwix-skill-section-02 section-padding">
            <div className="container">
                <div className="skill-wrap">
                    <div className="row">
                        <div className="col-lg-6" style={{textAlign: "left"}}>
                            <div className="skill-left">
                                <div className="section-title">
                                    <h2 className="title">Preparing for your success, we provide truly prominent IT solutions</h2>
                                </div>
                                <div className="experience-wrap">
                                    <div className="experience">
                                        <h2 className="number">10</h2>
                                        <span>Years of <br/> experience</span>
                                    </div>
                                    <div className="experience-text">
                                        <p>Our primary goal is to understand your business needs and deliver tailored
                                            solutions that precisely meet your demands.</p>
                                        <Link className="learn-more" to="/about">learn More About Us <i className="fas fa-long-arrow-alt-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="skill-right">
                                <div className="counter-bar">
                                    <div className="skill-item">
                                        <span className="title">Data Science</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="80">
                                                    <span className="skill-percent"><span className="">80</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Software Development</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="95">
                                                    <span className="skill-percent"><span className="">95</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Information Technology</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="80">
                                                    <span className="skill-percent"><span className="">80</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-item">
                                        <span className="title">Technology Consultant</span>
                                        <div className="skill-bar">
                                            <div className="bar-inner">
                                                <div className="bar progress-line color-1" data-width="90">
                                                    <span className="skill-percent"><span className="">90</span>%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>


        <div className="section techwix-case-study-section-02 section-padding" style={{backgroundImage: "url(assets/images/bg/case-study-bg.jpg)"}}>
            <div className="container">
                <div className="case-study-wrap">
                    <div className="section-title text-center">
                        <h3 className="sub-title">From our Case studies</h3>
                        <h2 className="title white">We delivered best solution</h2>
                    </div>
                </div>
            </div>


            <div className="case-study-content-wrap">
                <div className="swiper-container case-study-active">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="single-case-study-02">
                                <div className="case-study-img">
                                    <Link to="/service"><img src="assets/images/case-4.jpg" alt="" /></Link>
                                </div>
                                <div className="case-study-content">
                                    <p className="sub-title">Database Security</p>
                                    <h3 className="title"><Link to="/service"><span>Structure</span> <br/> <span>of Malnufication</span></Link></h3>
                                    <p className="text">Accelerate innovation with world-class tech teams We’ll match you to an entire remote team of incredible freelance talent for all your </p>
                                </div>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="single-case-study-02">
                                <div className="case-study-img">
                                    <Link to="/service"><img src="assets/images/case-5.jpg" alt="" /></Link>
                                </div>
                                <div className="case-study-content">
                                    <p className="sub-title">Database Security</p>
                                    <h3 className="title"><Link to="/service"><span>Multifunctional</span> <br/> <span>of Technology</span></Link></h3>
                                    <p className="text">Accelerate innovation with world-class tech teams We’ll match you to an entire remote team of incredible freelance talent for all your </p>
                                </div>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="single-case-study-02">
                                <div className="case-study-img">
                                    <Link to="/service"><img src="assets/images/case-6.jpg" alt=""/></Link>
                                </div>
                                <div className="case-study-content">
                                    <p className="sub-title">Database Security</p>
                                    <h3 className="title"><Link to="/service"><span>Blockchain</span> <br/> <span>of technology</span></Link></h3>
                                    <p className="text">Accelerate innovation with world-class tech teams We’ll match you to an entire remote team of incredible freelance talent for all your </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="swiper-pagination"></div>
                </div>
            </div>
        </div>
        </div>
     );
}
 
export default About;